









import { useGuideDriver } from '@/hooks/use-guide-driver';
// import { i18n } from '@/i18n';
// import { language } from '@tencent/ppd-base-libs';
// import { biClick } from '@tencent/fit-bi-sdk';
import { defineComponent, ref, toRefs, watch } from '@vue/composition-api';
// import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import { disableBodyScroll/* , enableBodyScroll*/ } from '../../utils/page-scroll';
import NewUserDialog from './new-user-dialog.vue';

// enum PageName  {
//   STAMP = 'stamp',
//   COUPON = 'coupon',
//   TASK ='task'
// }

export default defineComponent({
  components: { NewUserDialog  },
  name: 'GuideModule',
  setup() {
    const isShowNewUserDialog = ref(false);
    const guideDriver = useGuideDriver();
    const { isShow } = toRefs(guideDriver.showConfig);

    // const lang = language.getLanguage();
    // const curStep = ref(PageName.STAMP);
    // const isClickStep3OnNext = ref(false);
    // let animatedTourDriver ;

    // const onNextBi = (pageName: PageName) => {
    //   biClick('mainpage.nextstep_click', { fpageName: pageName });
    // };

    // const onSkipBi = (pageName: PageName) => {
    //   biClick('mainpage.skip_click', { fpageName: pageName });
    // };

    /** 步骤的定义 */
    // const tourSteps = [
    //   {
    //     element: '#stampModule',
    //     popover: {
    //       className: 'stamp-popover-class',
    //       title: i18n('此處查看每個月已儲印花'),
    //       position: 'top',
    //     },
    //     onNext: () => {
    //       onNextBi(curStep.value);
    //       curStep.value = PageName.COUPON;
    //     },
    //   },
    //   {
    //     element: '#activityModuleCoupon',
    //     popover: {
    //       className: 'coupon-popover-class',
    //       title: i18n('此處拎豐富獎賞'),
    //       position: 'top',
    //     },
    //     onNext: () => {
    //       onNextBi(curStep.value);
    //       curStep.value = PageName.TASK;
    //     },
    //   },
    //   {
    //     element: '#activityModuleTask',
    //     popover: {
    //       className: 'task-popover-class',
    //       title: i18n('此處查看印花任務'),
    //       position: 'top',
    //     },
    //     onNext: () => {
    //       onNextBi(curStep.value);
    //       // 为了用来区分onReset是因为点击【跳过】还是因为点击步骤3的下一步
    //       isClickStep3OnNext.value = true;
    //     },
    //   },
    // ];
    /** 引导的整体定义 */
    // const driverConfig  = {
    //   className: `e-stamp-guide ${lang}`,
    //   animate: true,
    //   opacity: 0.8,
    //   overlayClickNext: true,          // Whether the click on overlay should move next
    //   keyboardControl: false,            // Allow controlling through keyboard (escape to close, arrow keys to move)
    //   showButtons: true,
    //   padding: 0,                      // Distance of element from around the edges
    //   allowClose: false,                 // Whether the click on overlay should close or not
    //   nextBtnText: i18n('下一步'),
    //   doneBtnText: i18n('下一步'),              // Text on the final button
    //   closeBtnText: i18n('跳過'),            // Text on the close button for this step
    //   stageBackground: 'transparent',       // Background color for the staged behind highlighted element
    //   scrollIntoViewOptions: {
    //     block: 'end' as any,
    //     inline: '' as any, // 解决driver滚动问题
    //   },
    //   onReset: () => {  // Called when overlay is about to be cleared
    //     if (!isClickStep3OnNext.value) {
    //       // 为了用来区分onReset是因为点击【跳过】还是因为点击步骤3的下一步
    //       onSkipBi(curStep.value);
    //     }
    //     enableBodyScroll();
    //     isShowNewUserDialog.value = true;
    //   },
    // };

    /** 點擊新人彈窗-去兌換 */
    const goExchange = () => {
      isShowNewUserDialog.value = false;
      guideDriver.endGuide();
    };

    /** 開始新人指引 */
    const startDriver = () => {
      // animatedTourDriver = new Driver(driverConfig);
      // animatedTourDriver.defineSteps(tourSteps as any);
      // animatedTourDriver.start();
      // 直接展示新手dialog，不需要引导步骤了
      isShowNewUserDialog.value = true;
      disableBodyScroll();
    };

    watch(isShow, () => {
      if (isShow.value) {
        startDriver();
      }
    });

    return { isShowNewUserDialog,  goExchange };
  },
});
